import type {CorePlugin} from '../types'
import {variantsPlugin} from './variants'
import {defaultsPlugin} from './defaults'
import {rawExportPlugin} from './rawExport'
import {componentTypePlugin} from './componentType'
import {undefinedPlugin} from './undefined'
import {wixCodeConnectionPlugin} from './wixCodeConnection'
import {versionPlugin} from './version'
import {classicLayoutPlugin} from './classicLayout'

export const corePlugins: CorePlugin[] = [
    versionPlugin,
    undefinedPlugin,
    defaultsPlugin,
    variantsPlugin,
    classicLayoutPlugin,
    rawExportPlugin,
    componentTypePlugin,
    wixCodeConnectionPlugin
]
